export default "/_next/static/images/membershipBannerMobile-4084b96d36bd5d0ba4af3300c8c51573.png";